import styled from 'styled-components'
import Fonts, { weight, family } from 'components/base-ui/Fonts'
import { Button } from 'components/base-ui'

const Wrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
`

const Detail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background: ${({ theme }) => theme.colors.primary};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`

const Profile = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const ProfileImage = styled.img`
  border-radius: 50%;
  width: 36px;
  height: 36px;
  border: 2px solid ${({ theme }) => theme.colors.white};

  @media (max-width: 360px) {
    width: 32px;
    height: 32px;
  }
`

const Title = styled(Fonts.BaseBold)`
  font-weight: ${weight.semiBold};
  font-family: ${family.brand};
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: 360px) {
    font-size: 12px;
  }
`

const Description = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.white};
  @media (max-width: 360px) {
    font-size: 10px;
  }
`

const MembershipCard = styled.img`
  height: 40px;
  width: 60px;
  border: 1px solid #fff;
  border-radius: 4px;

  @media (max-width: 360px) {
    height: 35px;
    width: 55px;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px;

  @media (max-width: 360px) {
    padding: 6px;
  }
`

const PrivilegeButton = styled(Button)`
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: ${weight.semiBold};
  min-height: 22px;
  height: fit-content;
  width: auto;

  @media (max-width: 360px) {
    font-size: 10px;
    padding: 4px 12px;
  }
`

const PrivilegeText = styled(Fonts.SmallTitleBold)`
  color: ${({ theme }) => theme.colors.primary};
  @media (max-width: 360px) {
    font-size: 10px;
  }
`

const CouponDesc = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`

export {
  Wrapper,
  Detail,
  Profile,
  ProfileImage,
  Title,
  Description,
  Footer,
  MembershipCard,
  PrivilegeButton,
  PrivilegeText,
  CouponDesc,
}
